<template>
    <CRow>
        <CCol col="12" lg="8" xl="6">
            <div :class="this.$func.storyblok2Css(blok, 'text-default')">
                <rich-text-renderer :document="blok.richtext" />
            </div>
        </CCol>
    </CRow>
</template>

<script>
    export default {
        props: ['blok']
    }
</script>